import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenterVertical,
  FlexColCenter,
  FlexRowCenter,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  theme: any;
  unit: string;
  count: string;
  onChange: (newValue: string, sholudUpdateCart?: boolean) => void;
  step?: number;
  marginToUnits?: number;
}

function ImitradeCountSetter({
  theme,
  unit,
  count,
  onChange,
  step = 1,
  marginToUnits = 0,
}: Props) {
  const handleChange = e => {
    const newValue = e.target.value;
    onChange(newValue, false);
  };

  const handleBlur = e => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleMinusChange = () => {
    const newValue = parseFloat(count) - step;
    const minValue = newValue < step ? step : newValue;
    if (minValue !== parseFloat(count)) {
      onChange(minValue.toFixed(0));
    }
  };

  const handlePlusChange = () => {
    const newValue = parseFloat(count) + step;
    onChange(newValue.toFixed(0));
  };

  return (
    <CountWrapper>
      <Wrapper>
        <IconWrapper title="Menej" onClick={handleMinusChange}>
          <SvgIcon
            width={8}
            height={2}
            icon={IconType.minus}
            viewBox="0 0 8 2"
            alt="Menej"
            title="Menej"
            fill={theme.colors.textPrimary}
            cursor={'pointer'}
          />
        </IconWrapper>
        <Input
          name="count"
          value={count}
          onChange={handleChange}
          onBlur={handleBlur}
          type="number"
          min="0.001"
        />
        <IconWrapper title="Viac" onClick={handlePlusChange}>
          <SvgIcon
            width={8}
            height={36}
            icon={IconType.plus}
            viewBox="0 0 8 8"
            alt="Viac"
            title="Viac"
            fill={theme.colors.textPrimary}
            cursor={'pointer'}
          />
        </IconWrapper>
      </Wrapper>
      <Unit marginToUnits={marginToUnits}>{unit}</Unit>
    </CountWrapper>
  );
}

const CountWrapper = styled(FlexRowCenterVertical)``;

const Wrapper = styled(FlexRowCenter)`
  border: ${({ theme }) => theme.borders.secondary};
  border-radius: ${rem(4)};
  width: ${rem(120)};
  height: ${rem(48)};
  padding: ${rem(16)} 0;
  margin-right: ${rem(16)};
`;

const Input = styled.input`
  display: block;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  border: 0;
  border-top: ${({ theme }) => theme.borders.secondary};
  border-bottom: ${({ theme }) => theme.borders.secondary};
  border-radius: ${rem(2)};
  padding: 0;
  text-align: center;
  box-shadow: none;
  height: ${rem(48)};
  width: ${rem(38)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 300;
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};
  outline: none;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
`;

const IconWrapper = styled(FlexColCenter)`
  width: 100%;
  cursor: pointer;
  height: ${rem(48)};
`;

const Unit = styled(TextP)<{ marginToUnits: number }>`
  font-size: ${rem(14)};
  font-weight: 300;
  line-height: ${rem(22)};
  color: black;
  margin-left: ${({ marginToUnits }) =>
    marginToUnits ? rem(marginToUnits) : 0};
`;

const WithThemeCountSetter: any = withTheme(ImitradeCountSetter);
export { WithThemeCountSetter as ImitradeCountSetter };
